import internalStateService from "../app/InternalStateService";
import { bindActionCreators } from "redux";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export default function(actionCreators) {
    return dispatch => {
        var mappedActionCreators = {};

        if (!actionCreators) {
            WEBUILogs.error("Missing action creators.");
            return;
        }

        Object.keys(actionCreators).forEach(actionNameKey => {
            var actionName = actionCreators[actionNameKey];
            //console.log("Adding action creator: " + actionName);

            mappedActionCreators[actionNameKey] = internalStateService.getActionByName(actionName);
        });

        return bindActionCreators(mappedActionCreators, dispatch);
    };
}
